import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Link, Stack, Text, VStack } from '@chakra-ui/react';
import { Icon, Path } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import FacilitiesModal from '../../FacilitiesModal';
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function RoomFacilitiesComponent(_ref) {
  var facilities = _ref.facilities,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanMd = _ref.isLessThanMd,
    containerRef = _ref.containerRef;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var getTypographyProps = useSemanticTypography();
  var visibleFacilities = facilities === null || facilities === void 0 ? void 0 : facilities.filter(item => item === null || item === void 0 ? void 0 : item.isVisible).slice(0, isLessThanMd && !isLessThanSm ? 3 : 5);
  var facilityNameLegacyTypography = {
    fontSize: 'xs',
    lineHeight: '2'
  };
  var facilityNameSemanticTypography = {
    textStyle: 'body-s-regular'
  };
  var linkNameLegacyTypography = {
    fontSize: 'sm'
  };
  var linkNameSemanticTypography = {
    textStyle: 'link-s-regular'
  };
  var linkLayoutStyles = {
    color: 'btnSecondaryEnabled',
    textDecoration: 'underline',
    textAlign: 'center'
  };
  return _jsxs(_Fragment, {
    children: [renderItems(), renderModal()]
  });
  function renderItems() {
    var containerStyles = {
      flexDirection: {
        base: 'column',
        sm: 'row'
      },
      alignItems: {
        base: 'flex-start',
        sm: 'initial'
      },
      maxWidth: 'full',
      overflow: 'auto'
    };
    var plusIconStyles = {
      w: 'var(--chakra-space-xl)',
      h: 'var(--chakra-space-xl)',
      justifyContent: 'center',
      alignItems: 'center',
      bgColor: 'lightGrey5',
      borderRadius: 'full'
    };
    var iconStyles = {
      h: {
        base: '6',
        sm: '8'
      },
      mr: {
        base: '3',
        sm: '0'
      }
    };
    return _jsxs(Flex, _objectSpread(_objectSpread({}, containerStyles), {}, {
      children: [_jsxs(Stack, {
        direction: {
          base: 'row'
        },
        spacing: {
          base: 'sm',
          sm: 'xl'
        },
        flexWrap: {
          base: 'wrap',
          sm: 'initial'
        },
        "data-testid": "room-facilities-wrap",
        children: [visibleFacilities === null || visibleFacilities === void 0 ? void 0 : visibleFacilities.map(roomFacility => _jsx(Box, {
          children: _jsxs(VStack, {
            spacing: "sm",
            children: [_jsx(Icon, _objectSpread(_objectSpread({}, iconStyles), {}, {
              src: formatAssetsUrl(roomFacility === null || roomFacility === void 0 ? void 0 : roomFacility.icon)
            })), !isLessThanSm && _jsx(Text, _objectSpread(_objectSpread({
              textAlign: "center"
            }, getTypographyProps(facilityNameLegacyTypography, facilityNameSemanticTypography)), {}, {
              children: roomFacility === null || roomFacility === void 0 ? void 0 : roomFacility.name
            }))]
          })
        }, roomFacility === null || roomFacility === void 0 ? void 0 : roomFacility.code)), facilities && (facilities === null || facilities === void 0 ? void 0 : facilities.length) > 5 && !isLessThanSm && _jsx(Box, {
          children: _jsxs(VStack, {
            spacing: "sm",
            children: [_jsx(Flex, _objectSpread(_objectSpread({}, plusIconStyles), {}, {
              children: _jsx(Icon, {
                svg: _jsx(Path, {
                  color: 'var(--chakra-colors-darkGrey2)'
                }),
                cursor: "pointer"
              })
            })), _jsx(Link, _objectSpread(_objectSpread(_objectSpread({}, linkLayoutStyles), getTypographyProps(linkNameLegacyTypography, linkNameSemanticTypography)), {}, {
              onMouseDown: openModal,
              "data-testid": "facilities-desktop-link",
              children: t('hoteldetails.seeall.facilities')
            }))]
          })
        })]
      }), isLessThanSm && _jsx(Box, {
        children: _jsx(Link, _objectSpread(_objectSpread(_objectSpread({}, linkLayoutStyles), getTypographyProps(linkNameLegacyTypography, linkNameSemanticTypography)), {}, {
          mt: "md",
          display: "block",
          onMouseDown: openModal,
          "data-testid": "facilities-mobile-link",
          children: t('hoteldetails.seeall.facilities')
        }))
      })]
    }));
  }
  function renderModal() {
    return _jsx(FacilitiesModal, {
      facilities: facilities,
      isModalVisible: isModalVisible,
      onModalClose: () => setIsModalVisible(false),
      containerRef: containerRef
    });
  }
  function openModal() {
    setIsModalVisible(true);
  }
}